import { Component, OnInit, OnDestroy } from '@angular/core';
import { DialogService } from '../dialog/index';
import { DialogComponent } from '../dialog/dialog.component';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable, Subscription } from 'rxjs';
import { PosService } from 'src/app/lazy/private/services/pos.service';
import { MainService } from 'src/app/services/main.service';
import { OrderViewComponent } from './order-view/order-view.component';

export interface SOModel {
  title: string;
  Items: any;
}

@Component({
  selector: 'app-sales-order',
  templateUrl: './sales-order.component.html',
  styleUrls: ['./sales-order.component.css']
})
export class SalesOrderComponent extends DialogComponent<SOModel, boolean>
  implements SOModel, OnInit {
  title: string;
  Items: any;
  result: any = { result: false, RtnItem: {} };
  selTab = 1;
  listData$: Observable<any>;
  subscriptionList$: Array<Subscription> = [];
  loadingList: any;
  constructor(
    dialogService: DialogService,
    private f_db: AngularFireDatabase,
    private pos: PosService,
    private ms: MainService
  ) {
    super(dialogService);
  }
  tab = [
    { id: 1, name: 'Pending', icon: 'fa-history' },
    { id: 2, name: 'Confirmed', icon: 'fa-television' }
  ];
  // list = this.Items;
  ngOnInit() {
    this.listData$ = this.f_db.list('Teams').valueChanges();
    this.subscriptionList$.push(
      this.listData$.subscribe(res => {
        this.loadingList = {};
      })
    )
    // this.f_db.list('Teams').valueChanges().subscribe(res => {
    //   this.Items = res;
    // });
    // this.listData$.subscribe(res => {
    // })
  }
  selectTab(i) {
    this.selTab = i.id;
  }
  getData(d) {
    return d.Notifications[0];
  }

  get_InvNo(str: string) {
    return str.substring(0, 5);
  }
  updateStatus(status: number, data) {
    let s = '';
    switch (status) {
      case 1:
        s = 'Accept';
        data.order_status = 13;
        break;
      case 2:
        s = 'View';
        break;
      case 3:
        s = 'Cancel';
        data.order_status = 21;
        break;
    }
    const params = { order_id: data.id, action: s, description: 'iPOS' }
    this.pos.Update_Ecom_Status(params).subscribe(res => {
    })
  }
  acceptOrder(s: number, data: any) {
    if (confirm('Do you want to Accept order?')) {
      this.loadingList[data.order_refno] = true;
      this.loadingList[data.order_refno + 'A'] = true;
      this.updateStatus(s, data);
    }
  }
  // ngOnDestroy() {
  //   this.subscriptionList$.forEach(sub$ => sub$.unsubscribe());
  // }
  viewOrder(data: any) {
    this.dialogService.addDialog(OrderViewComponent, { title: data.order_refno, item: data })
      .subscribe(res => {
      });
  }
  convertToSale(i) {
    this.result.result = true;
    this.result.RtnItem = i;
    this.close();
  }
}
